import type { AxiosError } from 'axios'
import type { Plugin } from 'vue'
import type { NamiApiPluginOptions } from '../interfaces/INamiApiPlugin'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { apiConfig } from '../classes/ApiConfigManager'
import { createLogger, useLogger } from '../composables/useLogger'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => {
                const maxRetries = 3
                const axiosError = error as AxiosError

                if (failureCount >= maxRetries || !axiosError.response) {
                    return false
                }

                const { status, config } = axiosError.response
                const logger = useLogger()

                if (status === 500) {
                    logger.logError(
                        `status code: ${status}, login name:${apiConfig.getLoginName()}, request config: ${JSON.stringify(config)}`,
                    )
                }
                else {
                    logger.logInformation(
                        `AxiosRetry times(${failureCount}):: status code: ${status}, request url: ${config.url}`,
                    )
                }

                return true
            },
            retryDelay: attemptIndex => attemptIndex * 1000,
        },
        mutations: {
            retry: false,
        },
    },
})

export const NamiApiRegister: Plugin<[NamiApiPluginOptions]> = {
    install(app, options) {
        // Initialize VueQuery plugin
        app.use(VueQueryPlugin, {
            queryClient,
        })

        // Initialize API configuration
        apiConfig.setConfig(options.apiConfig)

        // Initialize and install logger
        const loggerPlugin = createLogger(options.logger)
        app.use(loggerPlugin)
    },
}
